import React from "react";
import {
  Smartphone,
  Calendar,
  Mail,
  HelpCircle,
  Briefcase,
} from "lucide-react";
import { AppConfig } from "../../utils/Constants";

const MobileMessage: React.FC = () => {
  return (
    <div className="flex flex-col w-full min-h-screen bg-background-default dark:bg-background-dark relative overflow-hidden subtle-grid home-grid-subtle">
      <div className="relative flex-1 flex items-start justify-center px-6 pt-20 pb-16 z-10">
        <div className="max-w-md w-full">
          {/* Icon */}
          <div className="mb-8 flex justify-center">
            <div className="p-3 bg-background-panel dark:bg-background-paperDark/50 border border-divider/50 dark:border-divider-dark/30 rounded-lg">
              <Smartphone className="w-8 h-8 text-black dark:text-text-primaryDark" />
            </div>
          </div>

          {/* Header */}
          <div className="text-center mb-8 pb-6 border-b-2 border-black dark:border-divider-dark">
            <h1 className="text-3xl font-semibold text-black dark:text-text-primaryDark mb-2 tracking-tight">
              Desktop Access Required
            </h1>
            <p className="text-base text-black dark:text-text-secondaryDark">
              {AppConfig.PRODUCT_NAME} is optimized for desktop environments to
              deliver the full power of our RevOps automation and AI
              capabilities.
            </p>
          </div>

          {/* Links */}
          <div className="space-y-3">
            <a
              href="https://calendly.com/brantley-jnol/meeting"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-between px-5 py-3.5 bg-black dark:bg-white text-white dark:text-black rounded-md hover:bg-black/90 dark:hover:bg-white/90 transition-all duration-200 shadow-sm"
            >
              <div className="flex items-center gap-3">
                <Calendar className="w-4 h-4" />
                <span className="text-sm font-medium">Schedule</span>
              </div>
              <span className="text-sm">→</span>
            </a>

            <a
              href={AppConfig.SERVICES_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-between px-5 py-3.5 bg-background-paper dark:bg-background-paperDark border border-black/12 dark:border-divider-dark rounded-md hover:border-black/20 dark:hover:border-divider-dark hover:shadow-sm transition-all duration-200"
            >
              <div className="flex items-center gap-3">
                <Briefcase className="w-4 h-4 text-black dark:text-text-primaryDark" />
                <span className="text-sm font-medium text-black dark:text-text-primaryDark">
                  Services
                </span>
              </div>
              <span className="text-sm text-black dark:text-text-primaryDark">
                →
              </span>
            </a>

            <a
              href={`mailto:${AppConfig.SUPPORT_EMAIL}`}
              className="group flex items-center justify-between px-5 py-3.5 bg-background-paper dark:bg-background-paperDark border border-black/12 dark:border-divider-dark rounded-md hover:border-black/20 dark:hover:border-divider-dark hover:shadow-sm transition-all duration-200"
            >
              <div className="flex items-center gap-3">
                <HelpCircle className="w-4 h-4 text-black dark:text-text-primaryDark" />
                <span className="text-sm font-medium text-black dark:text-text-primaryDark">
                  Support
                </span>
              </div>
              <span className="text-sm text-black dark:text-text-primaryDark">
                →
              </span>
            </a>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer 
        className="mobile-footer-solid fixed bottom-0 left-0 right-0 h-[44px] flex items-center justify-center"
      >
        <div className="flex items-center gap-4 text-xs text-white dark:text-white px-6">
          <span>{AppConfig.PRODUCT_NAME_SHORT}</span>
          <span className="text-white/60 dark:text-white/60">
            v{AppConfig.VERSION}
          </span>
        </div>
      </footer>
    </div>
  );
};

export default MobileMessage;
